import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import "./style.css";
import Imperial from "../../components/Imperial/Imperial";
import ToggleNormalized from "../../components/ToggleNormalized/ToggleNormalized";
import { GetNormalizedState } from "../../store/Session/helper/NormalizedValues";
import { LmLocation } from "../../models";
import Spinner from "../../components/Spinner/Spinner";
const TopBar: React.FC = () => {
  const sessionData = useSelector((state: RootState) => state.session);
  // KWSA-37: Simulator sessions carry the Full Swing Sports mark; everything
  // shared from the Golf app keeps the KIT logo.
  const isSimulator = sessionData.location === LmLocation.SIMULATOR;
  // KWSA-42: which logo to show depends on the location, so until the session
  // has loaded there is nothing to show but a spinner.
  const isLoading = sessionData.status !== "success";

  return (
    <>
      <div className="top-bar-logo">
        {isLoading ? (
          <div className="logo-loading">
            <Spinner />
          </div>
        ) : (
          <img
            src={isSimulator ? "/img/logov2.png" : "/img/fs-logo.svg"}
            alt=""
            className={`logo-full-swing${isSimulator ? " logo-sports" : ""}`}
          />
        )}
        <div className="imperial-normalized-toggles">
          <Imperial measuringSystem={sessionData.measuringSystem} />
          <ToggleNormalized
            isNormalized={sessionData.isNormalized}
            normalizedState={GetNormalizedState(sessionData)}
          />
        </div>
      </div>
      <div className="session-name-text">{sessionData.name || ""}</div>
    </>
  );
};

export default TopBar;
